export default function IconSkipPrev() {
  return (
    <svg width="32" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M34.5647 31.2944C37.5664 32.9493 40 31.5936 40 28.2688L40 3.73356C40 0.405479 37.5664 -0.948444 34.5647 0.704856L12.2519 13.0035C9.24918 14.6589 9.24918 17.341 12.2519 18.996L34.5647 31.2944Z"
        fill="currentColor" />
      <path
        d="M5.33398 2.66667C5.33398 1.19391 4.14008 0 2.66732 0C1.19456 0 0.000652313 1.19391 0.000652313 2.66667V29.3333C0.000652313 30.8061 1.19456 32 2.66732 32C4.14008 32 5.33398 30.8061 5.33398 29.3333V2.66667Z"
        fill="currentColor" />
    </svg>
  );
}
